/**
 * Shared vocabulary + math for the "Labeled Modes" box-weight UI. Keeping these
 * in one place is the point of the design: every surface must use the same
 * words so "Ship weight" never drifts into "total" / "package weight".
 */

/** Billable weight on rates/labels — the primary number on every surface. */
export const SHIP_WEIGHT_LABEL = 'Ship weight'
/** Editable items-only weight, shown only when box weight auto-adds. */
export const CONTENT_WEIGHT_LABEL = 'Content weight'

export const BOX_WEIGHT_ADDED_HINT = 'box weight added at purchase'

/** Helper shown when nothing auto-adds and the user owns the box weight. */
export const INCLUDE_BOX_HELPER = 'Include the weight of the box — nothing is added automatically.'

export const BOX_WEIGHT_TOOLTIP =
  'Box weight from your custom box is added when rating and buying a label. ' +
  'Edit content weight above; box weight comes from the box catalog.'

/** Ship weight = content + box; box weight is `null` when auto-add is off. */
export function getShipWeight(contentWeight?: number | null, boxWeight?: number | null) {
  return (contentWeight ?? 0) + (boxWeight ?? 0)
}
